import Vue          from 'vue'
import IdleVue      from 'idle-vue'
import App          from './App'
import { router }   from './router'
import store        from './store'
import axios        from 'axios'
import VueAxios     from 'vue-axios'
import VueLoading   from 'vuex-loading'
import Vuetify      from 'vuetify'
import '../node_modules/mdi/css/materialdesignicons.css'
import _            from 'lodash'
import Vue2TouchEvents from 'vue2-touch-events'

// (
//     function () {
//         if ('serviceWorker' in navigator) {
//             navigator.serviceWorker.register('./service-worker.js', {scope: '/'})
//             .then(() => console.log('Service Worker registered successfully.'))
//             .catch(error => console.log('Service Worker registration failed:', error));
//         }
//     }
// )();

const eventsHub = new Vue()
Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    idleTime: 1000 * 3600 * 2
})

Vue.use(VueAxios, axios)

Vue.use(Vuetify, {
    theme: {
        primary:    '#CE7DD6'
    }
})

Vue.use(Vue2TouchEvents, {
    disableClick: false,
    touchClass: '',
    tapTolerance: 10,
    swipeTolerance: 30,
    longTapTimeInterval: 400
})

Vue.use(VueLoading)

Vue.config.productionTip = false

Vue.prototype.$eventHub = new Vue()

Vue.prototype.$_ = _

new Vue({
    el: '#app',
    router,
    store,
    vueLoading: new VueLoading({ useVuex: true, moduleName: 'loading' }),
    template: '<App/>',
    components: { App },

    onIdle() {
        store.dispatch('logout')
    }
})



// WEBPACK FOOTER //
// ./src/main.js